/**
 * @module manifest/groupRegistryDefs
 * @description 配置项组 defineGroup 声明入口（派生 groupRegistry / upload-keys）
 */

import type { IGroupDefinition } from '../defineGroup';
import { ALL_REGISTERED_GROUP_DEFS } from './allGroups';

export const REGISTERED_GROUP_DEFS: readonly IGroupDefinition[] =
  ALL_REGISTERED_GROUP_DEFS;

const registeredById: Record<string, IGroupDefinition> = {};
REGISTERED_GROUP_DEFS.forEach(def => {
  registeredById[def.id] = def;
});

export const REGISTERED_GROUP_BY_ID: Readonly<
  Record<string, IGroupDefinition>
> = registeredById;

export * from './allGroups';
